import React, { useState } from "react";
import PageHeader from "../components/PageHeader";
import CrudTable from "../components/CrudTable";
import PlanDetayModal from "../components/PlanDetayModal";
import QuickPlanModal from "../components/QuickPlanModal";

const trTarih = (s) => {
  if (!s) return "";
  const p = String(s).slice(0, 10).split("-");
  return p.length === 3 ? `${p[2]}.${p[1]}.${p[0]}` : s;
};

export default function Stock() {
  const [detay, setDetay] = useState(null);   // { kalip, aciklama }
  const [quick, setQuick] = useState(null);    // { kalip, aciklama, makina, eksik }
  const [refreshKey, setRefreshKey] = useState(0);

  const columns = [
    { key: "sira_no", label: "Sıra No", num: true },
    { key: "kalip_kodu", label: "Kalıp Kodu", mono: true },
    { key: "urun_aciklamasi", label: "Ürün Açıklaması" },
    { key: "makina", label: "Makine" },
    { key: "makina_kapasitesi", label: "Makina Kapasitesi", num: true, render: (r) => <span className="text-indigo-700 font-semibold">{r.makina_kapasitesi != null && r.makina_kapasitesi !== "" ? Number(r.makina_kapasitesi).toLocaleString("tr-TR") : "—"}</span> },
    { key: "firin_bolgesi", label: "Fırın Bölgesi" },
    { key: "kg_agirlik", label: "KG Ağırlık", num: true },
    { key: "sekillenen", label: "Şekillenen Ürün", num: true },
    {
      key: "sekillendirme_plani", label: "Şekillendirme Planı",
      value: (r) => {
        const plan = Number(r.sekillendirme_plani) || 0;
        if (!plan) return (Number(r.kalan_stok) || 0) < 0 ? "Plan Yok" : "";
        return `${plan.toLocaleString("tr-TR")}${r.sekillendirme_plani_durum ? " (" + r.sekillendirme_plani_durum + ")" : ""}`;
      },
      render: (r) => {
        const plan = Number(r.sekillendirme_plani) || 0;
        const durum = r.sekillendirme_plani_durum;
        if (!plan) {
          const neg = (Number(r.kalan_stok) || 0) < 0;
          if (!neg) return <span className="text-zinc-300">—</span>;
          return (
            <span className="inline-flex items-center gap-2" onClick={(e) => e.stopPropagation()}>
              <span className="inline-block rounded-full bg-red-100 text-red-700 border border-red-200 px-2 py-0.5 text-[11px] font-bold" data-testid={`stok-plan-yok-${r.kalip_kodu}`}>Plan Yok</span>
              <button type="button" onClick={() => setQuick({ kalip: r.kalip_kodu, aciklama: r.urun_aciklamasi, makina: r.makina, eksik: Math.abs(Number(r.kalan_stok) || 0) })}
                data-testid={`stok-plan-olustur-${r.kalip_kodu}`}
                className="inline-flex items-center gap-1 bg-amber-600 hover:bg-amber-700 text-white text-[11px] font-semibold px-2 py-0.5 rounded-full transition-colors">+ Plan</button>
            </span>
          );
        }
        const dcls = durum === "Üretimde" ? "bg-amber-100 text-amber-700 border border-amber-200" : "bg-violet-100 text-violet-700 border border-violet-200";
        return (
          <button type="button" onClick={(e) => { e.stopPropagation(); setDetay({ kalip: r.kalip_kodu, aciklama: r.urun_aciklamasi }); }}
            data-testid={`stok-plan-ac-${r.kalip_kodu}`}
            className="inline-flex items-center gap-1.5 flex-wrap hover:bg-violet-50 rounded-md px-1.5 py-1 transition-colors cursor-pointer">
            <span className="font-semibold text-violet-700 num">{plan.toLocaleString("tr-TR")}</span>
            {durum && <span className={`inline-block rounded-full px-2 py-0.5 text-[11px] font-bold ${dcls}`}>{durum}</span>}
          </button>
        );
      },
    },
    { key: "firin_yukleme", label: "Bisküvi Fırın Yükleme", num: true },
    {
      key: "kalan_sekillenen", label: "Kalan Şekillenen Ürün", num: true,
      value: (r) => r.kalan_sekillenen,
      render: (r) => {
        const v = Number(r.kalan_sekillenen) || 0;
        const cls = v < 0 ? "text-red-600" : v > 0 ? "text-amber-700" : "text-sky-600";
        return <span className={`font-bold ${cls}`}>{v.toLocaleString("tr-TR")}</span>;
      },
    },
    { key: "devir_biskuvi", label: "Devir Bisküvi Adet", num: true },
    { key: "uretilen_biskuvi", label: "Üretilen Bisküvi", num: true },
    {
      key: "kalan_sekillenecek", label: "Şekillenen ve Üretim Farkı", num: true,
      value: (r) => r.kalan_sekillenecek,
      render: (r) => {
        const v = Number(r.kalan_sekillenecek) || 0;
        const cls = v < 0 ? "text-red-600" : v > 0 ? "text-amber-700" : "text-sky-600";
        return <span className={`font-bold ${cls}`}>{v.toLocaleString("tr-TR")}</span>;
      },
    },
    { key: "yapilan_urun", label: "Yapılan Ürün", num: true },
    {
      key: "biskuvi_stok", label: "Bisküvi Stok", num: true,
      value: (r) => r.biskuvi_stok,
      render: (r) => {
        const v = Number(r.biskuvi_stok) || 0;
        return v < 0
          ? <span className="inline-flex items-center gap-1 bg-red-100 text-red-700 font-bold rounded px-2 py-0.5">{v.toLocaleString("tr-TR")}</span>
          : <span className="font-semibold text-zinc-700">{v.toLocaleString("tr-TR")}</span>;
      },
    },
    { key: "guncel_siparis", label: "Güncel Sipariş Adeti", num: true },
    {
      key: "kalan_stok", label: "Kalan Bisküvi Stok ve Şekillenecek Ürün", num: true,
      value: (r) => r.kalan_stok,
      render: (r) => {
        const v = Number(r.kalan_stok) || 0;
        const cls = v < 0 ? "text-red-600" : v > 0 ? "text-green-700" : "text-sky-600";
        return <span className={`font-bold ${cls}`}>{v.toLocaleString("tr-TR")}</span>;
      },
    },
    {
      key: "terminler", label: "Termin Tarihleri (Eksik Stok)",
      value: (r) => (r.terminler || []).map((t) => trTarih(t.termin)).join(", "),
      render: (r) => {
        const list = r.terminler || [];
        if ((Number(r.kalan_stok) || 0) >= 0 || list.length === 0) return <span className="text-zinc-300">—</span>;
        return (
          <div className="flex flex-wrap gap-1">
            {list.map((t, i) => (
              <span key={i} className="inline-flex items-center gap-1 bg-red-50 text-red-700 border border-red-200 rounded-sm px-1.5 py-0.5 text-xs font-semibold whitespace-nowrap">
                {trTarih(t.termin)} <span className="text-red-400">({t.kalan})</span>
              </span>
            ))}
          </div>
        );
      },
    },
  ];
  const fields = [
    { key: "sira_no", label: "Sıra No", type: "number" },
    { key: "kalip_kodu", label: "Kalıp Kodu", type: "text", mono: true, required: true },
    { key: "urun_aciklamasi", label: "Ürün Açıklaması", type: "text", span: 2 },
    { key: "makina", label: "Makine", type: "text" },
    { key: "makina_kapasitesi", label: "Makina Kapasitesi", type: "number" },
    { key: "firin_bolgesi", label: "Fırın Bölgesi", type: "text" },
    { key: "kg_agirlik", label: "KG Ağırlık", type: "number" },
  ];
  return (
    <>
      <PageHeader title="Bisküvi Stok" subtitle="Şekillenen, üretilen ve yapılan ürüne göre otomatik hesaplanır (devir manuel girilir)" />
      <CrudTable key={refreshKey} endpoint="/entity/stock" listEndpoint="/stock/computed" columns={columns} fields={fields}
        titleSingular="Stok Kalemi" printTitle="Bisküvi Stok" exportKind="stock" negativeCols={["kalan_stok"]} adminOnlyEdit
        warnNegativeKey="biskuvi_stok" warnMessage="Bisküvi stoğu negatif olan ürünler var — üretim/planlama gerekiyor." />
      {detay && <PlanDetayModal kalip={detay.kalip} aciklama={detay.aciklama} onClose={() => setDetay(null)} />}
      {quick && <QuickPlanModal kalip={quick.kalip} aciklama={quick.aciklama} makina={quick.makina} eksik={quick.eksik}
        onClose={() => setQuick(null)} onCreated={() => setRefreshKey((k) => k + 1)} />}
    </>
  );
}
